import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { CHANGE_LANGUAGE } from 'app/shared/utils';

@Component({
    selector: 'app-sign-up-status',
    templateUrl: './sign-up-status.component.html',
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MatIconModule,
        TranslateModule,
        RouterModule,
    ],
    standalone: true,
    styles: [
        `
            :host {
                width: 100%;
            }
        `,
    ],
})
export class SignUpStatusComponent {
    calendarEventURL = '';
    countdown = 5;

    constructor(
        private router: Router,
        private activatedRoute: ActivatedRoute,
        public translate: TranslateService
    ) {
        let result = this.router.getCurrentNavigation().extras.state?.result;
        if (!result || result == undefined) {
            this.router.navigate(['/sign-up']);
        }
    }

    ngOnInit() {
        // assigning returnUrl flag for redirection
        this.activatedRoute.queryParams.subscribe((params) => {
            this.calendarEventURL = params.calendarEventURL;
        });
        if (!localStorage.getItem('reload')) {
            localStorage.setItem('reload', 'no reload');
            location.reload();
        } else {
            localStorage.removeItem('reload');
        }
    }

    ngAfterViewInit() {
        const timer = setInterval(() => {
            this.countdown--;
            if (this.countdown <= 0) {
                clearInterval(timer);
                this.onSignIn();
            }
        }, 1000);
    }

    onSignIn() {
        if (this.calendarEventURL) {
            this.router.navigate(['/login'], {
                state: { result: 'done', isRegistered: true },
                queryParams: {
                    calendarEventURL: this.calendarEventURL,
                },
            });
        } else {
            this.router.navigate(['/login']);
        }
    }

    switchLanguage(language: string) {
        CHANGE_LANGUAGE(language, this.router.url, this.translate);
    }
}
